// Canvas v2 undo/redo. Snapshots the layout-relevant slice
// (items + guides + groups + selection) on every committed mutation.
// Transient drag state lives in pointer.js SESSION (not snapshotted).

const STACK = { past: [], future: [], suspended: 0 }
const MAX = 100

function snapshot(canvas) {
  return JSON.stringify({
    items: canvas.items, guides: canvas.guides,
    groups: canvas.groups, selection: canvas.selection
  })
}

function restore(el, snap) {
  const v2 = el.call('getCanvasV2'); if (!v2) return
  const data = JSON.parse(snap)
  STACK.suspended++
  try {
    el.call('patchCanvas', { items: data.items, guides: data.guides, groups: data.groups, selection: data.selection })
    el.call('refreshCanvasChrome')
  } finally { STACK.suspended-- }
}

// Push a new snapshot to the past stack. Clears the redo (future) on
// branch. Skipped while a restore is in flight.
export function pushHistory() {
  if (STACK.suspended) return
  const v2 = this.call('getCanvasV2'); if (!v2) return
  const snap = snapshot(v2)
  const top = STACK.past[STACK.past.length - 1]
  if (top === snap) return
  STACK.past.push(snap)
  if (STACK.past.length > MAX) STACK.past.shift()
  STACK.future.length = 0
}

export function undo() {
  if (STACK.past.length < 2) return
  const cur = STACK.past.pop()
  STACK.future.push(cur)
  restore(this, STACK.past[STACK.past.length - 1])
}

export function redo() {
  const next = STACK.future.pop()
  if (!next) return
  STACK.past.push(next)
  restore(this, next)
}
